"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyInfoModule = void 0;
var tslib_1 = require("tslib");
var kebabCase_1 = (0, tslib_1.__importDefault)(require("lodash/kebabCase"));
var React = (0, tslib_1.__importStar)(require("react"));
var test_helpers_1 = require("../../lib/test-helpers");
var colors_1 = require("../../theme/colors");
var flexbox_1 = require("../flexbox");
var padding_1 = require("../padding");
var text_1 = require("../text");
var text_link_1 = require("../text-link");
function EmptyInfoModule(_a) {
    var title = _a.title, actionLink = _a.actionLink, onActionLinkClick = _a.onActionLinkClick, propTestId = _a.testId;
    var testId = propTestId || (0, kebabCase_1.default)(title);
    return (React.createElement(padding_1.Padding, { top: 12, bottom: 20, testId: testId },
        React.createElement(flexbox_1.Flexbox, { alignItems: "center", flexDirection: "column" },
            React.createElement(text_1.Text, { size: "small", color: colors_1.colors.steel[400] }, title),
            onActionLinkClick && actionLink ? (React.createElement(flexbox_1.Flexbox, { justifyContent: "center" },
                React.createElement(text_link_1.TextLink, { type: "button", size: "small", onClick: onActionLinkClick, style: { textAlign: 'center' }, underline: false, testId: (0, test_helpers_1.generateTestId)(testId, 'link') }, actionLink))) : null)));
}
exports.EmptyInfoModule = EmptyInfoModule;
//# sourceMappingURL=index.js.map